import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=4867c555"
import script from "./EventList.vue?vue&type=script&setup=true&lang=js"
export * from "./EventList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports